import { userReducer, USER_FEATURE_KEY } from './user';

export const reducer = {
  [USER_FEATURE_KEY]: userReducer,
};
